import ActivityContent from 'Activity';

const Activity = () => {
  return <ActivityContent tab="news" />;
};

export default Activity;
